module.exports = __webpack_public_path__ + "img/gif-focus-en.83fadd2a.gif";